module.exports = __webpack_public_path__ + "static/media/LeftSpeaker.a30db571.svg";